<template>
  <div id="headerUI">
    <TabletToolUI></TabletToolUI>
    <TabletHistoryUI></TabletHistoryUI>
    <TabletSaveUI></TabletSaveUI>
  </div>
</template>

<script>
import TabletToolUI from "./TabletToolUI";
import TabletHistoryUI from "./TabletHistoryUI";
import TabletSaveUI from "./TabletSaveUI";
export default {
  name: "HeaderUI",
  components: {
    TabletToolUI,
    TabletSaveUI,
    TabletHistoryUI
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/zindex"
@import "../../sass/common"
#headerUI
    position: fixed
    z-index: $z_header_ui
    @include flexCenter
    justify-content: space-between
    width: 100%
    height: 67px
    padding: 0 33px
    background-color: #000000
</style>
